import { useEffect, useState } from "react";
import { Box, Grid } from "@mui/joy";

import { AlbumWidget } from "../../../components";
import { useTask } from "../../../hooks/query";
import { API_ENDPOINTS } from "../../../constants";

interface IPropertyPhotos {
    taskDetails: {
        Id: string;
        ProjectId: string;
    };
}

export function PropertyPhotos(props: IPropertyPhotos) {
    const { taskDetails } = { ...props };
    const { useListAssets } = useTask();
    const listAssetsSvc = useListAssets();

    const [imageGroups, setImageGroups] = useState<any>([]);

    const fetchData = async () => {
        try {
            if (!taskDetails.Id) {
                // task id not found
                return;
            }
            const params = {
                TaskId: taskDetails.Id,
                AssetType: "TASK:FINAL_SETTLEMENT",
            };
            const response = await listAssetsSvc.mutateAsync(params);
            return response;
        } catch (e) {
            console.error(e);
        }
    };

    const groupImages = (serverImages: any[]) => {
        const images = roofingPhotoSections.map((group: any) => {
            const groupAssets = serverImages.filter((serverImage: any) => serverImage.Label === group.label);
            return {
                ...group,
                images: groupAssets.map((groupAsset: any) => API_ENDPOINTS.asset.getImageAsSrc(groupAsset.AssetId)),
            };
        });

        setImageGroups(images);
    };
    useEffect(() => {
        fetchData().then((assetData: any) => {
            groupImages(assetData);
        });
    }, []);

    return (
        <Box sx={{ mx: "auto", mt: 0 }}>
            <Grid container spacing={2} mt={1}>
                {imageGroups.map((e: any) => {
                    return (
                        <Grid xs={12} key={e.id}>
                            <AlbumWidget {...e} taskId={taskDetails.Id} projectId={taskDetails.ProjectId} />
                        </Grid>
                    );
                })}
            </Grid>
        </Box>
    );
}

const roofingPhotoSections = [
    {
        id: "frontHouse",
        title: "Front of House Showing Address",
        label: "TASK:FINAL_SETTLEMENT:FHSA",
        description: "Capture a wide shot showing the address and the overall front view of the property.",
        coverImage: "https://frontgate.scene7.com/is/image/frontgate/b-75716_main?$wfih$",
    },
    {
        id: "slopeOverview",
        title: "Overview of Each Slope",
        label: "TASK:FINAL_SETTLEMENT:OOES",
        description: "Photos showing the condition and angles of each slope of the roof.",
        coverImage: "https://th.bing.com/th/id/OIP.FXGnl5iVTRl628OV_sHtBgHaEK?rs=1&pid=ImgDetMain",
    },
    {
        id: "penetrationCloseups",
        title: "Close-up of Every Penetration (Pipe Jack, Roof Vent, etc.)",
        label: "TASK:FINAL_SETTLEMENT:COEP",
        description: "Close-up shots of all roof penetrations, including vents, pipes, and other elements.",
        coverImage: "https://th.bing.com/th/id/OIP.YQiiGgOu67qKRXIaoujb7wHaE8?rs=1&pid=ImgDetMain",
    },
    {
        id: "metalFlashings",
        title: "All Metal Flashings (Drip Edge, Step Flashing, etc.)",
        label: "TASK:FINAL_SETTLEMENT:AMFL",
        description: "Images of all metal flashings used, including drip edge, step flashings, and more.",
        coverImage: "https://th.bing.com/th/id/OIP.PE6VypBM2vaWUv4Hg9LJNAHaEK?rs=1&pid=ImgDetMain",
    },
    {
        id: "ridgeCapNails",
        title: "Exposed Ridge Cap Nails, Showing They Have Been Sealed",
        label: "TASK:FINAL_SETTLEMENT:RCNS",
        description: "Detailed photos showing the ridge cap nails and their proper sealing.",
        coverImage:
            "https://encompasshomeinspectionservice.com/wp-content/uploads/2023/05/roof-repairs-maintenance.jpg",
    },
];
